import { getCssVariableByName } from '../../../utils/css-utils';

const SELECTED_MONDAY_COLORS = [
  '--color-snow_white',
  '--color-wolf_gray',
  '--color-asphalt',
  '--color-basic_blue',
  '--color-dark_blue',
  '--color-success',
  '--color-success-hover',
  '--color-brand-gold',
  '--color-egg_yolk',
  '--color-orange',
  '--color-zip-orange',
  '--color-dark-orange',
  '--color-error',
  '--color-error-hover',
  '--color-pdf-red',
  '--color-dark_red',
  '--color-brand-iris',
  '--color-brand-purple',
  '--color-dark-purple',
  '--color-mud_black',
  '--color-black',
];

const getMondayColors = () => {
  return SELECTED_MONDAY_COLORS.map(getCssVariableByName);
};

export const TOOLBAR_BUTTONS_TAGS = {
  SELECT: 'select',
  BUTTON: 'button',
};

export const toolbarConfig = [
  {
    name: 'header',
    options: ['', 1, 2, 3, 4, 5, 6],
    tag: TOOLBAR_BUTTONS_TAGS.SELECT,
    width: 98,
  },
  {
    name: 'align',
    options: [],
    tag: TOOLBAR_BUTTONS_TAGS.SELECT,
  },
  {
    name: 'link',
    tag: TOOLBAR_BUTTONS_TAGS.BUTTON,
  },
  {
    name: 'color',
    options: () => getMondayColors(),
    tag: TOOLBAR_BUTTONS_TAGS.SELECT,
  },
  {
    name: 'background',
    options: () => getMondayColors(),
    tag: TOOLBAR_BUTTONS_TAGS.SELECT,
  },
  {
    name: 'bold',
    tag: TOOLBAR_BUTTONS_TAGS.BUTTON,
  },
  {
    name: 'italic',
    tag: TOOLBAR_BUTTONS_TAGS.BUTTON,
  },
  {
    name: 'underline',
    tag: TOOLBAR_BUTTONS_TAGS.BUTTON,
  },
  {
    name: 'strike',
    tag: TOOLBAR_BUTTONS_TAGS.BUTTON,
  },
  {
    name: 'blockquote',
    tag: TOOLBAR_BUTTONS_TAGS.BUTTON,
  },
  {
    name: 'code-block',
    tag: TOOLBAR_BUTTONS_TAGS.BUTTON,
  },
  {
    name: 'list',
    value: 'ordered',
    tag: TOOLBAR_BUTTONS_TAGS.BUTTON,
  },
  {
    name: 'list',
    value: 'bullet',
    tag: TOOLBAR_BUTTONS_TAGS.BUTTON,
  },
];
